import { render, staticRenderFns } from "./LoaderIcon.vue?vue&type=template&id=cb4a0b2c&"
import script from "./LoaderIcon.vue?vue&type=script&lang=js&"
export * from "./LoaderIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../voice.mave.work/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports